
import React, { useState, useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";
import axios from 'axios';
import _ from 'underscore';
import SaveAlt from "@material-ui/icons/SaveAlt";
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const convertDataToArray = (data, keys) => data.map(obj => Array.from(keys, k=>obj[k]||null))

export default class RemoteTable extends React.Component {
    constructor(props){
        super();
        this.state={
            data: {datos:[],total:0},
            page: {pagina:0,filas:100,orderBy:null,direction:null}
        }
        this.textLabels = {
            body: {
              noMatch: "No se encontraron registros",
              toolTip: "Ordenar",
            },
            pagination: {
              next: "Siguiente",
              previous: "Anterior",
              rowsPerPage: "Filas por página:",
              displayRows: "de",
            },
            toolbar: {
              search: "Buscar",
              downloadCsv: "Descargar CSV",
              print: "Imprimir",
              viewColumns: "Ver Columnas",
              filterTable: "Filtrar",
            },
            filter: {
              all: "TODOS",
              title: "FILTROS",
              reset: "REESTABLECER",
            },
            viewColumns: {
              title: "Mostrar Columnas",
              titleAria: "Mostrar/Esconder Columnas",
            },
            selectedRows: {
              text: "fila(s) seleccionada(s)",
              delete: "Eliminar",
              deleteAria: "Eliminar las Columas Seleccionadas",
            },
          }
          this.actualizaTabla = this.actualizaTabla.bind(this);
    }
    actualizaTabla(props){
        if(props.query){
            props.query({
                ...props.data,
                ...this.state.page
            })    
        }else{
            axios({
                url: props.url,
                method: props.method || "get",
                data: {
                    ...this.state.page,
                    ...props.data
                }
            }).then(data => {
                if(data){
                    this.setState({data});
                }
            });
        }
    }
    componentWillMount(){
        this.actualizaTabla(this.props);
    }
    componentWillReceiveProps(props){
        if(!_.isEqual(props.data,this.props.data)){
            this.actualizaTabla(props);
        }
        if(props.contenido && !_.isEqual(props.contenido,this.props.contenido)){
            this.setState({data:props.contenido});
        }
    }
    shouldComponentUpdate(props,state){
        return !_.isEqual(state.data,this.state.data)
    }

    render (){
        return <Paper>
            <MuiThemeProvider theme={()=>createMuiTheme({
                overrides: {
                    MUIDataTable: {
                        responsiveScroll: {
                          maxHeight: 'none',
                        },
                      },
                    MUIDataTableBodyCell: {
                        root: {
                            padding: 3,
                            textWrap: 'wrap'
                        }
                    },
                    MUIDataTableHeadCell:{
                        root:{
                            padding: 4
                        }
                    }
                },
                typography: {
                    useNextVariants: true
                }
            })}>
            <MUIDataTable
                columns={this.props.columns}
                data={convertDataToArray(this.state.data.datos, this.props.columns.map(o=>o.key))}
                title={this.props.title}
                options={{
                    selectableRows: this.props.selection!==undefined?this.props.selection:true,
                    responsive: "scroll",
                    textLabels:this.textLabels,
                    count: this.state.data.total,
                    filter:false,
                    print: false,
                    sort: this.props.sort!==undefined?this.props.sort:true,
                    search: false,
                    download: false,
                    viewColumns:false,
                    rowsPerPage:this.state.page.filas,
                    rowsPerPageOptions:false,
                    serverSide: true,
                    onRowClick: this.props.onRowClick!==undefined?this.props.onRowClick:null,
                    onChangePage: (currentPage) => {
                        this.setState({page:{...this.state.page,pagina:currentPage}},()=>this.actualizaTabla(this.props));
                    },
                    onChangeRowsPerPage: (numberOfRows)=> {
                        this.setState({page:{...this.state.page,filas:numberOfRows}},()=>this.actualizaTabla(this.props));
                    },
                    onColumnSortChange: (changedColumn, direction) => {
                        var column = _.findWhere(this.props.columns, { name: changedColumn });
                        this.setState({page:{...this.state.page,orderBy:column.key,direction}},()=>this.actualizaTabla(this.props));
                    },
                    customToolbar: ()=><div>
                        <Tooltip title={"Descargar CSV"}>
                            <IconButton onClick={()=>{
                                var url = this.props.url;
                                var n = url.lastIndexOf('/');
                                axios({
                                    url: (url.substring(0,n) + '/CSV' + url.substring(n)),
                                    method: this.props.method || "get",
                                    data: {
                                        ...this.props.data
                                    },
                                    responseType: 'blob'
                                }).then(o => {
                                    if (o) {
                                        var blob = o instanceof Blob ? o : (o.data instanceof Blob ? o.data : new Blob([o], { type: 'text/csv;charset=utf-8;' }));
                                        var downloadUrl = window.URL.createObjectURL(blob);
                                        var downloadLink = document.createElement("a");
                                        downloadLink.href = downloadUrl;
                                        downloadLink.download = "AsyntecDTE.csv";
                            
                                        document.body.appendChild(downloadLink);
                                        downloadLink.click();
                                        document.body.removeChild(downloadLink);
                                        window.URL.revokeObjectURL(downloadUrl);
                                    }
                                }).catch(()=> alert("Archivo no disponible."))
                            }}>
                                <SaveAlt/>
                            </IconButton>
                        </Tooltip>
                    </div>,
                    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
                        var filas = displayData.filter(e => selectedRows.data.map(o => o.dataIndex).includes(e.dataIndex))
                        if(this.props.setSelectedRows) this.props.setSelectedRows(filas)
                        if(this.props.CustomToolBar){
                            return <this.props.CustomToolBar selectedRows={filas} setSelectedRows= {setSelectedRows}  />
                        }
                      },
                    customFooter: this.props.CustomFooter || null
                  }}
            />
            </MuiThemeProvider>
        </Paper>
    };
}